import { GfFlyerItem } from "@swagger/typescript-fetch-goflyer";

export type FlyerItemFieldsWithoutDuplicateIdentity = Omit<
  GfFlyerItem,
  | "id"
  | "createdAt"
  | "updatedAt"
  | "slug"
  | "flyerItemList"
  | "gfMultiImages"
  | "gfImages"
  | "flyer"
  | "shoppingListFlyerItems"
  | "adminUser"
  | "coordinate"
  | "isDeleted"
>;

/**
 * Payload for reusing field values from `gfFlyerItemAdminControllerFindFlyerItemByImageAndStore`
 * when creating a **new** flyer item draft. Drops identity, timestamps, slug, relational fields,
 * and stale list/layout/metadata so merged draft state keeps the current list and selected images
 * instead of inheriting them from the matched source item.
 */
export function flyerItemFieldsWithoutDuplicateIdentity(
  flyerItemResponse: GfFlyerItem | null | undefined,
): FlyerItemFieldsWithoutDuplicateIdentity {
  if (flyerItemResponse == null) {
    return {} as FlyerItemFieldsWithoutDuplicateIdentity;
  }
  const {
    id: _id,
    updatedAt: _updatedAt,
    createdAt: _createdAt,
    slug: _slug,
    flyerItemList: _flyerItemList,
    gfMultiImages: _gfMultiImages,
    gfImages: _gfImages,
    flyer: _flyer,
    shoppingListFlyerItems: _shoppingListFlyerItems,
    adminUser: _adminUser,
    coordinate: _coordinate,
    isDeleted: _isDeleted,
    ...rest
  } = flyerItemResponse;
  return rest;
}
